import { Button } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  primary: boolean;
  persistLocalStorage?: boolean;
};

const RetryButton: React.FC<Props> = ({ primary, persistLocalStorage = false }) => (
  <Button
    data-id="retry-button"
    appearance={primary ? "primary" : undefined}
    onClick={() => {
      // Set expiry date of all cookies in the past (which basically removes all cookies)
      const Cookies = document.cookie.split(";");
      for (let i = 0; i < Cookies.length; i++) {
        document.cookie = `${Cookies[i]}=; expires=${new Date(0).toUTCString()}`;
      }

      if (!persistLocalStorage) {
        window.localStorage.clear();
      }

      window.location.reload();
    }}
  >
    <FormattedMessage id="retry.button.text" />
  </Button>
);

export default RetryButton;
